/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  AuthorizedUser,
  AuthorizedUserFromJSON,
  AuthorizedUserToJSON,
} from '../models/AuthorizedUser';
import * as runtime from '../runtime';

export interface AuthorizedUserCreateRequest {
  data?: AuthorizedUser;
}

export interface AuthorizedUserDeleteByIdRequest {
  id: string;
}

export interface AuthorizedUserDeleteByIdNumberRequest {
  idNumber: number;
}

export interface AuthorizedUserFindRequest {
  filter?: string;
}

export interface AuthorizedUserFindByIdRequest {
  id: string;
  filter?: string;
}

export interface AuthorizedUserPatchAttributesRequest {
  id: string;
  data?: AuthorizedUser;
}

/**
 *
 */
export class AuthorizedUserApi extends runtime.BaseAPI {
  /**
   * Create a new instance of the model and persist it into the data source.
   */
  async authorizedUserCreateRaw(
    requestParameters: AuthorizedUserCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AuthorizedUser>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/AuthorizedUsers`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: AuthorizedUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AuthorizedUserFromJSON(jsonValue)
    );
  }

  /**
   * Create a new instance of the model and persist it into the data source.
   */
  async authorizedUserCreate(
    requestParameters: AuthorizedUserCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AuthorizedUser> {
    const response = await this.authorizedUserCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Delete a model instance by {{id}} from the data source.
   */
  async authorizedUserDeleteByIdRaw(
    requestParameters: AuthorizedUserDeleteByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling authorizedUserDeleteById().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/AuthorizedUsers/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Delete a model instance by {{id}} from the data source.
   */
  async authorizedUserDeleteById(
    requestParameters: AuthorizedUserDeleteByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.authorizedUserDeleteByIdRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Delete a model instance by {{idNumber}} from the data source.
   */
  async authorizedUserDeleteByIdNumberRaw(
    requestParameters: AuthorizedUserDeleteByIdNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['idNumber'] == null) {
      throw new runtime.RequiredError(
        'idNumber',
        'Required parameter "idNumber" was null or undefined when calling authorizedUserDeleteByIdNumber().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/AuthorizedUsers/idNumber/{idNumber}`.replace(
          `{${'idNumber'}}`,
          encodeURIComponent(String(requestParameters['idNumber']))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Delete a model instance by {{idNumber}} from the data source.
   */
  async authorizedUserDeleteByIdNumber(
    requestParameters: AuthorizedUserDeleteByIdNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.authorizedUserDeleteByIdNumberRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find all instances of the model matched by filter from the data source.
   */
  async authorizedUserFindRaw(
    requestParameters: AuthorizedUserFindRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<AuthorizedUser>>> {
    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/AuthorizedUsers`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AuthorizedUserFromJSON)
    );
  }

  /**
   * Find all instances of the model matched by filter from the data source.
   */
  async authorizedUserFind(
    requestParameters: AuthorizedUserFindRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<AuthorizedUser>> {
    const response = await this.authorizedUserFindRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Find a model instance by {{id}} from the data source.
   */
  async authorizedUserFindByIdRaw(
    requestParameters: AuthorizedUserFindByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AuthorizedUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling authorizedUserFindById().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters['filter'] != null) {
      queryParameters['filter'] = requestParameters['filter'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/AuthorizedUsers/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AuthorizedUserFromJSON(jsonValue)
    );
  }

  /**
   * Find a model instance by {{id}} from the data source.
   */
  async authorizedUserFindById(
    requestParameters: AuthorizedUserFindByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AuthorizedUser> {
    const response = await this.authorizedUserFindByIdRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Patch attributes for a model instance and persist it into the data source.
   */
  async authorizedUserPatchAttributesRaw(
    requestParameters: AuthorizedUserPatchAttributesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<AuthorizedUser>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling authorizedUserPatchAttributes().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/AuthorizedUsers/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id']))
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: AuthorizedUserToJSON(requestParameters['data']),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AuthorizedUserFromJSON(jsonValue)
    );
  }

  /**
   * Patch attributes for a model instance and persist it into the data source.
   */
  async authorizedUserPatchAttributes(
    requestParameters: AuthorizedUserPatchAttributesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<AuthorizedUser> {
    const response = await this.authorizedUserPatchAttributesRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
}
